export enum OtherData {
  MALE = '1',
  FEMALE = '2',
  EITHER = '99',
}
